angular.module('TetherApp').factory('listenerListService', [
    '$http',
    function($http) {

        let randomString = function randomString(length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let getList = function (listenerId) {
            let uri = '/api/v1/listeners/listener-lists' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' },
                    listener_id: listenerId
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let create = function (data) {
            return $http.post(
                '/api/v1/listener-list',
                data,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let update = function (data) {
            return $http.put(
                '/api/v1/listener-list/' + data.id,
                data,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let deleteListenerList = function (listenerId) {
            let uri = '/api/v1/listener-list/' + listenerId;
            return $http.delete(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        return {
            getList: getList,
            create: create,
            update: update,
            deleteListenerList: deleteListenerList
        }
    }
]);
